"use client";
import "./most-searched.scss";
import { getMostSearched } from "./service";
import { useState, useEffect, useMemo } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Navigation, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";
import ImageCommon from "@/src/component/image/image";
import { wrapperRouterPush } from "@/src/util/util";
import { useRouter } from "next/navigation";
import iconArrow from "@/public/icon/icon-swiper.svg";
import Image from "next/image";
import { Skeleton, Row, Col } from "antd";
import useWindowSize from "@/src/hooks/useWindowSize";
import iconStar from "@/public/icon/icon-start-3d.svg";
import iconLocation from "@/public/icon/icon-location-newest.svg";

export default function MostSearched() {
  const [loading, setLoading] = useState(true);
  const [dataMostSearched, setDataMostSearched] = useState([]);
  const { width } = useWindowSize();
  const router = useRouter();

  const chunkSize = width > 1072 ? 3 : width >= 768 ? 2 : 1;
  const colSpan = width > 1072 ? 8 : width >= 768 ? 12 : 24;

  const chunkData = (data) => {
    return data.reduce((result, _, index, array) => {
      if (index % chunkSize === 0)
        result.push(array.slice(index, index + chunkSize));
      return result;
    }, []);
  };

  const dataChunks = useMemo(
    () => chunkData(dataMostSearched),
    [dataMostSearched, width]
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        const { data } = await getMostSearched();
        setDataMostSearched(data || []);
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  return (
    <div className="wp-most-searched">
      <div className="section-title">NHA KHOA ĐƯỢC TÌM KIẾM NHIỀU NHẤT</div>
      {loading ? (
        <div className="swiper">
          <Row gutter={width <= 1072 ? 25 : 50} className="wp-row-slice">
            {Array.from({
              length: chunkSize,
            }).map((_, index) => (
              <Col key={index} span={colSpan}>
                <Skeleton.Input className="wp-clinic" active />
              </Col>
            ))}
          </Row>
        </div>
      ) : dataChunks?.length < 1 ? (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            fontSize: "16px",
            margin: "12px 0px",
          }}
        >
          Chưa có thông tin
        </div>
      ) : (
        <>
          <Swiper
            slidesPerView={1}
            spaceBetween={16}
            autoplay={{ delay: 3000, disableOnInteraction: false }}
            loop={true}
            pagination={{ clickable: true }}
            navigation={{ nextEl: "#button-R", prevEl: "#button-L" }}
            modules={[
              Autoplay, Pagination, Navigation]}
          >
            {dataChunks.map((chunk, chunkIndex) => (
              <SwiperSlide key={chunkIndex}>
                <Row gutter={width <= 1072 ? 25 : 50} className="wp-row-slice">
                  {chunk.map((item, itemIndex) => (
                    <Col key={item.slug} span={colSpan}>
                      <div
                        className="wp-clinic"
                        onClick={() =>
                          wrapperRouterPush(router, `/phong-kham/${item.slug}`)
                        }
                      >
                        <ImageCommon
                          data={item.image[0] || null}
                          style="clinic-logo"
                        />
                        <div className="wp-clinic-info">
                          <div className="clinic-title">{item.name}</div>
                          <div className={"wpRatingLine"}>
                            {item?.rating_overview?.overall_average ? (
                              <>
                                <div className={"wpRatingInLine"}>
                                  <div className={"ratingPoint"}>
                                    <div className={"point"}>
                                      {item?.rating_overview?.overall_average.toFixed(
                                        1
                                      )}
                                    </div>
                                    <Image
                                      className="iconRatingStar"
                                      src={iconStar}
                                      alt="icon"
                                      width={15}
                                      height={15}
                                    />
                                  </div>
                                </div>
                                <div className={"dash"}></div>
                              </>
                            ) : null}
                            <div className={"ratingQuantity"}>
                              {item?.rating_overview?.number_of_ratings
                                ? item?.rating_overview?.number_of_ratings
                                : 0}{" "}
                              Đánh giá
                            </div>
                            <div className={"dash"}></div>
                            <div className={"numberOfConsultation"}>
                              {item?.total_contact ? item?.total_contact : 0}{" "}
                              Người đặt lịch
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  ))}
                </Row>
              </SwiperSlide>
            ))}
          </Swiper>
          <button className="arrow-left arrow" id="button-L">
            <Image
              className="icon-arrow icon-prev"
              src={iconArrow}
              alt="Previous slide"
            />
          </button>
          <button className="arrow-right arrow" id="button-R">
            <Image className="icon-arrow" src={iconArrow} alt="Next slide" />
          </button>
        </>
      )}
    </div>
  );
}
